import { ReactElement } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { isPhoneDevice } from '@/utils/device';
import { useAuth } from '@/providers/AuthProvider';
import MobileDeviceBlock from './MobileDeviceBlock';

const mobileAllowedPaths = [
  /^\/session\/[^/]+\/player(\/|$)/,
  /^\/privacy-policy(\/|$)/
];

const isMobileAllowedPath = (pathname: string) =>
  mobileAllowedPaths.some((pattern) => pattern.test(pathname));

const MobileDeviceGate = (): ReactElement => {
  const location = useLocation();
  const { loaded, user } = useAuth();
  const shouldBlock = loaded && !!user && isPhoneDevice() && !isMobileAllowedPath(location.pathname);

  if (shouldBlock) {
    return <MobileDeviceBlock />;
  }

  return <Outlet />;
};

export default MobileDeviceGate;
